const isNavActive = function (pathname, url) {
  return pathname === url || (url !== '/' && pathname.includes(url))
}

module.exports = isNavActive
